import {
  formatDate,
  formatDateTime,
} from '@terminal/modules/impacted-companies/components/utils';
import { t } from 'i18next';

type OptionsProps = {
  createdAt: string;
  updatedAt?: string;
  fiscalYear?: string;
  fiscalPeriod?: string;
  releasedDate?: string;
  isPreview?: boolean;
  isAnalyzing?: boolean;
};

export const constructMetadataSentence = (options: OptionsProps): string => {
  const {
    createdAt,
    updatedAt,
    fiscalYear,
    fiscalPeriod,
    releasedDate,
    isPreview = false,
    isAnalyzing = false,
  } = options;

  if (isAnalyzing && releasedDate && fiscalYear && fiscalPeriod) {
    return t('earnings:earningsInsight.metadata.earningsAreBeingAnalyzed', {
      period: `${fiscalPeriod} ${fiscalYear}`,
      releasedDate: formatDate(new Date(releasedDate)),
    });
  }

  const parts: string[] = [];

  parts.push(
    t('earnings:earningsInsight.metadata.publishedWithDate', {
      date: formatDateTime(new Date(createdAt)),
    })
  );

  if (isPreview) {
    return parts.join('');
  }

  if (updatedAt) {
    parts.push(
      t('earnings:earningsInsight.metadata.updatedWithDate', {
        date: formatDateTime(new Date(updatedAt)),
      })
    );
  }

  if (fiscalYear && fiscalPeriod && releasedDate) {
    parts.push(
      t('earnings:earningsInsight.metadata.basedOnEarnings', {
        period: `${fiscalPeriod} ${fiscalYear}`,
        releasedDate: formatDate(new Date(releasedDate)),
      })
    );
  }

  return parts.join(' · ');
};
